<template>
    <div class="container" :class="{ 'dark-mode': isDarkMode }">
        <div class="intro" data-aos="fade-down" data-aos-easing="ease-in-out" data-aos-duration="800"
            data-aos-anchor-placement="top">
            <p class="section_p1">Technical And Professional</p>
            <h1 class="title">My Skills</h1>
        </div>

        <div class="experience-details">
            <div class="about-container">
                <!-- Front End -->
                <div class="details-container" data-aos="zoom-in" data-aos-easing="ease-in-out" data-aos-duration="900"
                    data-aos-anchor-placement="top-center">
                    <h2 class="experience-title" data-aos="fade-down" data-aos-easing="ease-in-out"
                        data-aos-duration="1000">Frontend Development</h2>
                    <div class="article-container">
                        <div class="article" v-for="(skill, index) in frontendSkills" :key="index" data-aos="fade-up"
                            data-aos-easing="ease-in-out" data-aos-duration="1000">
                            <div class="tag">
                                <i :class="skill.icon"></i>
                                <h3>{{ skill.name }}</h3>
                            </div>
                            <p>{{ skill.experience }}</p>
                        </div>
                    </div>
                </div>

                <!-- Back End -->
                <div class="details-container" data-aos="zoom-in" data-aos-easing="ease-in-out" data-aos-duration="900"
                    data-aos-anchor-placement="top-center">
                    <h2 class="experience-title" data-aos="fade-down" data-aos-easing="ease-in-out"
                        data-aos-duration="1000">Backend Development</h2>
                    <div class="article-container">
                        <div class="article" v-for="(skill, index) in backendSkills" :key="index" data-aos="fade-up"
                            data-aos-easing="ease-in-out" data-aos-duration="1000">
                            <div class="tag">
                                <i :class="skill.icon"></i>
                                <h3>{{ skill.name }}</h3>
                            </div>
                            <p>{{ skill.experience }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
    name: 'SkillCategory',
    data() {
        return {
            frontendSkills: [
                { name: "HTML", experience: "Experienced", icon: "fa-brands fa-html5" },
                { name: "CSS", experience: "Experienced", icon: "fa-brands fa-css3-alt" },
                { name: "SASS", experience: "Experienced", icon: "fa-brands fa-sass" },
                { name: "JavaScript", experience: "Intermediate", icon: "fa-brands fa-square-js" },
                { name: "Vue JS", experience: "Experienced", icon: "fa-brands fa-vuejs" },
                { name: "React JS", experience: "Basic", icon: "fa-brands fa-react" },
                { name: "Python", experience: "Basic", icon: "fa-brands fa-python" },
                { name: "PHP", experience: "Basic", icon: "fa-brands fa-php" },
            ],
            backendSkills: [
                { name: "Node JS", experience: "Intermediate", icon: "fa-brands fa-node" },
                { name: "Firebase", experience: "Experienced", icon: "fa-solid fa-folder-open" },
                { name: "SQL", experience: "Basic", icon: "fa-solid fa-database" },
                { name: "Express JS", experience: "Basic", icon: "fa-solid fa-truck-fast" },
                { name: "Git", experience: "Experienced", icon: "fa-brands fa-github" },
                { name: "MongoDB", experience: "Basic", icon: "fa-solid fa-server" },
            ],
        }
    },

    computed: {
        ...mapState(['isDarkMode'])
    }
}
</script>

<style lang="scss" scoped>
.container {
    padding-top: 4vh;
    width: 100%;
    min-height: 100vh;
    height: 100%;


    .experience-details {
        display: flex;
        justify-content: center;
        flex-direction: column;

        .about-container {
            display: flex;
            flex-direction: row;
            gap: 2rem;
            margin: 2rem 0;

            @media (max-width: 1200px) {
                flex-direction: column;
            }


            .details-container {
                position: relative;
                flex: 1;
                background: rgba(255, 255, 255, 0.37);
                backdrop-filter: blur(9px);
                border-radius: 2rem;
                font-size: 1rem;
                letter-spacing: 1px;
                text-align: center;
                transition: .7s;
                overflow: hidden;
                z-index: 1;
                padding: 1.5rem;
                margin: 0 auto;

                h3,
                h2,
                i {
                    color: black;
                }

                &::before {
                    content: "";
                    position: absolute;
                    top: 0;
                    left: 0;
                    background: black;
                    width: 0;
                    height: 100%;
                    z-index: -1;
                    transition: .3s;
                }

                &:hover::before {
                    width: 100%;
                }

                &:hover {

                    p,
                    h2,
                    h3,
                    i {
                        color: white;
                    }

                    box-shadow: 0 0 10px rgba(13, 0, 0, 1),
                    0px 0px 21px rgba(13, 0, 0, 0.078),
                    0px 0px 24px rgba(13, 0, 0, 0.082),
                    0px 1px 4px rgba(13, 0, 0, 0.016);

                    @media(max-width: 750px) {
                        box-shadow: 0 0 5px rgba(13, 0, 0, 1),
                        0px 0px 25px rgba(13, 0, 0, 0.6);
                    }
                }

                h2 {
                    font-weight: 600;
                    font-size: 1.75rem;
                    margin-bottom: 2rem;
                }

                .article-container {
                    display: flex;
                    text-align: initial;
                    flex-wrap: wrap;
                    flex-direction: row;
                    gap: 2rem;
                    justify-content: space-around;

                    .article {
                        display: flex;
                        flex-direction: column;
                        width: 10rem;
                        justify-content: space-around;

                        @media(max-width: 750px) {
                            font-size: 80%;
                        }


                        .tag {
                            display: inline-flex;
                            align-items: center;
                            gap: 0.5rem;

                            i {
                                cursor: default;
                            }
                        }
                    }
                }
            }
        }
    }
}

.dark-mode {
    .experience-details {
        .about-container {
            .details-container {
                background: rgba(255, 255, 255, 0.164);
                backdrop-filter: blur(9px);

                h3,
                h2,
                i {
                    color: white;
                }


                &::before {
                    background: white;
                }

                &:hover {

                    p,
                    h2,
                    h3,
                    i {
                        color: black;
                    }

                    box-shadow: 0 0 10px rgba(255, 255, 255, 1),
                    0 0 21px rgba(255, 255, 255, 0.8),
                    0 0 24px rgba(255, 255, 255, 0.6),
                    0 0 4px rgba(255, 255, 255, 0.4);

                    @media(max-width: 750px) {
                        box-shadow: 0 0 8px rgba(255, 255, 255, 1),
                        0 0 25px rgba(255, 255, 255, 0.6);
                    }
                }

                h2 {
                    font-weight: 600;
                    font-size: 1.75rem;
                    margin-bottom: 2rem;
                }
            }
        }
    }
}
</style>